"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Action = void 0;
var Action;
(function (Action) {
    Action["jsProPremiumAccess"] = "jsProPremiumAccess";
    Action["clickWVMPButton"] = "clickWVMPButton";
})(Action || (exports.Action = Action = {}));
